<template>
  <div class="yuLanBox">
    <!-- <el-dialog title="文档预览" :visible.sync="wendang">
      <iframe :src="wendangUrl" width="500px" height="600px"></iframe>
    </el-dialog> -->
    <div class="chakanwendang" v-if="wendang">
      <span @click="closeWd"><i class="el-icon-circle-close"></i></span>
      <iframe :src="wendangUrl" width="90%" height="90%" frameborder="0" ></iframe>
    </div>
     <!-- <vue-preview :slides="slide1" class="preview"></vue-preview> -->
     <el-image-viewer v-if="showViewer" :on-close="closeViewer" lock-scroll="true" :url-list="[url]" />
     <el-dialog title="视频预览" :visible.sync="shipinshow" @close="closeDialog">
      <video-player  class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
     </el-dialog>


  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';
export default {
  name:'yulan',
  data() {
    return {
      ccc:'预览',
      wendang:false,
      wendangUrl:'',
      showViewer:false,
      url:'',
      shipinshow:false,
      playerOptions : {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
    }

    }
  },
  components: { ElImageViewer, videoPlayer },
  props:{
    watchType:Number,
    fileUrl:String
  },
  watch:{
    watchType:{
      handler(v){
        this.yulan();
      },
      deep:true
    },
    fileUrl:{
      handler(v){
        this.yulan();
      },
      deep:true
    }
  },
  mounted() {

  },
  methods: {
    // 预览
    yulan(){
      if(this.watchType<4){
        this.wendangUrl = this.fileUrl;
        this.wendang = true;
      }else if(this.watchType==4){
        this.url = this.fileUrl
        this.showViewer = true;
      }else if(this.watchType==5){
        var obg = {};
        // var fileExtension =fileName.substring(fileName.length-3,fileName.length).toLowerCase();
          obg.src = this.fileUrl;
          var houzhui = this.fileUrl.substring(this.fileUrl.length-3,this.fileUrl.length).toLowerCase();
          obg.type = 'video/' + houzhui;
          this.playerOptions.sources.push(obg);
          this.shipinshow = true;
        // this.url = this.fileUrl;
      }else if(this.watchType==6){
        return;
      }else{
        this.$message({
          message:'当前文档不支持预览！',
          type:'warning'
        })
      }
    },
    closeViewer(){
      this.$emit("watch-type",6);
      this.showViewer = false;
    },
    closeWd(){
      this.$emit("watch-type",6);
      this.wendang = false;
    },
    closeDialog(){
      this.$emit("watch-type",6);
      this.shipinshow = false;
    }

  }

}
</script>

<style>
/* .yuLanBox{ position: fixed; left: 0; top: 0; right: 0; bottom: 0;} */
.chakanwendang{ position: fixed; left: 0; top: 0; right: 0; bottom: 0; margin: auto; background: rgba(0,0,0,.4); z-index: 1000;}
.chakanwendang span{ position: absolute; right: 10px; top: 10px; width:40px; height: 40px; text-align: center; line-height: 40px; color: #FFF; font-size: 30px; cursor: pointer;}
iframe{ position: absolute; left: 0; top: 0; right: 0; bottom: 0; margin: auto; background: #ffffff;}
</style>



// WEBPACK FOOTER //
// src/components/yulan.vue